module.exports = __webpack_public_path__ + "static/img/xingHalf.5b468e52.svg";